import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=2f2b2597&scoped=true&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"
import style0 from "./Network.vue?vue&type=style&index=0&id=2f2b2597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b2597",
  null
  
)

export default component.exports